import React from "react"

class Timeslot extends React.Component {

  render() {
    return (
      <span>{this.props.start_time} - {this.props.end_time}</span>
    )
  }
  
}

export default Timeslot